import React, { useState } from "react";
import { Button, Layout } from "antd";
import { isScreenMobile } from "Utils/";
import ParameterRoutes from "Routes/private/parameters";
import ParameterNavigation from "./components/navigation";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
const { Sider, Content } = Layout;

export default function ParametersLayout({ ...props }) {
  const [siderCollapsed, setSiderCollapsed] = useState(false);

  const handleOnCollapse = (collapsed) => {
    setSiderCollapsed(collapsed);
  };

  const handleMenuItemClick = (click) => {
    setSiderCollapsed(true);
  };

  return (
    <>
      <Layout style={{ height: "calc(100vh - 210px)" }}>
        <Sider
          collapsed={isScreenMobile() ? siderCollapsed : false}
          onCollapse={handleOnCollapse}
          collapsedWidth="0"
        >
          <ParameterNavigation
            onCollapseSider={() => {
              setSiderCollapsed(false);
            }}
          />
        </Sider>
        <Content style={{ padding: 0 }}>
          {isScreenMobile() ? (
            <Button
              style={{ marginRight: 8 }}
              onClick={() => {
                setSiderCollapsed(!siderCollapsed);
              }}
            >
              <FontAwesomeIcon icon={["fas", "bars"]} />
            </Button>
          ) : null}
          <ParameterRoutes />
        </Content>
      </Layout>
    </>
  );
}
